var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0.5H4.5C4.77386 0.5 5 0.726142 5 1C5 2.30065 5.20786 3.55078 5.59277 4.71875V4.71973C5.64937 4.89982 5.60912 5.09383 5.4668 5.23633L3.00977 7.69336L3.1748 8.0166C4.66318 10.9416 7.05996 13.3278 9.98242 14.8252L10.3057 14.9912L12.7539 12.543C12.8641 12.4383 12.9926 12.3896 13.1201 12.3896C13.154 12.3897 13.1817 12.3913 13.2041 12.3945C13.2264 12.3977 13.2389 12.4022 13.2441 12.4043L13.2588 12.4102L13.2734 12.415C14.4438 12.8016 15.7067 13.0098 17 13.0098C17.2738 13.0098 17.4999 13.236 17.5 13.5098V17C17.5 17.2739 17.2739 17.5 17 17.5C7.88614 17.5 0.5 10.1139 0.5 1C0.5 0.726142 0.726142 0.5 1 0.5ZM1.53125 2.03418C1.62422 3.39757 1.8925 4.71031 2.31641 5.95117L2.57617 6.71094L4.55273 4.73438L4.4707 4.45117C4.24116 3.65734 4.0968 2.82282 4.03906 1.9668L4.00781 1.5H1.49512L1.53125 2.03418ZM16.5 14.0029L16.0342 13.9707C15.1885 13.913 14.3525 13.7695 13.5361 13.5391L13.2549 13.46L13.0479 13.665L11.8477 14.8545L11.2695 15.4287L12.043 15.6846C13.2908 16.0971 14.6021 16.366 15.9658 16.459L16.5 16.4951V14.0029Z",
    fill: "#FD9D03",
    stroke: "#FD9D03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.972f7148f39e41d6409d280f59fb334a.svg";
export { ForwardRef as ReactComponent };